export const HEADER_BYTE_LENGTH = 5;
